import { render, staticRenderFns } from "./product-finish-pricing.vue?vue&type=template&id=1a1570d4&scoped=true&"
import script from "./product-finish-pricing.vue?vue&type=script&lang=js&"
export * from "./product-finish-pricing.vue?vue&type=script&lang=js&"
import style0 from "./product-finish-pricing.vue?vue&type=style&index=0&id=1a1570d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1570d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1570d4')) {
      api.createRecord('1a1570d4', component.options)
    } else {
      api.reload('1a1570d4', component.options)
    }
    module.hot.accept("./product-finish-pricing.vue?vue&type=template&id=1a1570d4&scoped=true&", function () {
      api.rerender('1a1570d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/components/product-finish-pricing.vue"
export default component.exports